import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/stephenayala/Downloads/Programming/FelicisWebsite/app/ui/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/stephenayala/Downloads/Programming/FelicisWebsite/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/stephenayala/Downloads/Programming/FelicisWebsite/node_modules/next/dist/client/image-component.js");
